import PropTypes from 'prop-types'
import { Divider, Paper, Typography } from '@aura/components'
import { withStyles } from '@aura/components/styles'
import styles from './styles'


const RegistrationContainer = ({
    classes,
    title,
    children,
    footerActions,
    mainContent,
    elevation = 2,
    variant = 'outlined'
}) => {
    return (
        <Paper 
            elevation={elevation} 
            variant={variant}
            className={classes.container}
        >
            {/* Header Section with Title and Optional Close Button */}
            {title && <div className={classes.header}>
                <Typography
                    className={classes.title}
                >
                    {title}
                </Typography>
            </div>}
            {title && <Divider className={classes.headerDivider} />}

            {/* Main Content Section */}
            {mainContent || children}

            {/* Footer Section with Optional Separator */}
            {footerActions && (
                <>
                    <Divider className={classes.footerDivider} />
                    <div className={classes.footerWrapper}>
                        {footerActions}
                    </div>
                </>
            )}
        </Paper>
    )
}

RegistrationContainer.displayName = 'RegistrationContainer'

RegistrationContainer.propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
    elevation: PropTypes.number,
    footerActions: PropTypes.node,
    onClose: PropTypes.func,
    showCloseButton: PropTypes.bool,
    title: PropTypes.string.isRequired,
    variant: PropTypes.oneOf([ 'elevation', 'outlined' ])
}

export default withStyles(RegistrationContainer, styles)